import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M13.5774 9.7556C13.9028 10.081 14.4305 10.081 14.7559 9.7556C15.0814 9.43016 15.0814 8.90252 14.7559 8.57709L10.5893 4.41042C10.2638 4.08498 9.73618 4.08498 9.41074 4.41042L5.24408 8.57709C4.91864 8.90252 4.91864 9.43016 5.24408 9.7556C5.56951 10.081 6.09715 10.081 6.42259 9.7556L10 6.17819L13.5774 9.7556Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M9.16667 14.9997C9.16667 15.4599 9.53976 15.833 10 15.833C10.4602 15.833 10.8333 15.4599 10.8333 14.9997L10.8333 4.99967C10.8333 4.53944 10.4602 4.16634 10 4.16634C9.53976 4.16634 9.16667 4.53944 9.16667 4.99967L9.16667 14.9997Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}